<template>
  <TsColumn dataTestid="column-saveList">
    <NuxtLinkWithLocale
        :data-testid="props.dataTestid
                      ? props.dataTestid + '_header-link-save-list'
                      : '_header-link-save-list'
                  "
        to="/account/saved-lists"
        class="hover:text-natural-light-grey cursor-pointer flex flex-col items-end lg:items-center lg:space-y-2"
    >
      <TsIcon
          name="gg:heart"
          :size="isDesktopScreen ? '22' : '28'"
      />

      <TsTypography
          v-if="isDesktopScreen"
          as="span"
          variant="sm"
          appendClass="leading-[12px] text-idle-white hidden lg:block whitespace-nowrap"
      >
        {{ useTranslation("saveList", "Kluslijst") }}
      </TsTypography>
    </NuxtLinkWithLocale>
  </TsColumn>
</template>
<script setup lang="ts">
import { useTranslation } from "~/composables/useTranslation";
import { useScreenSize } from "~/composables/useScreenSize";

const props = withDefaults(defineProps<Props>(), {});
type Props = {
  dataTestid?: string;
};

const { isDesktopScreen } = useScreenSize();
</script>